import { ContentChild, Directive, Input } from '@angular/core';
import { NgForOf } from '@angular/common';
import * as _ from 'lodash';
import { SortDirection } from './sort-direction.model';
import { Sorter } from './sorter.model';

@Directive({
    selector: 'table[sortable]',
    standalone: false
})
export class SortableTableDirective {

    @Input() sortable: any[];
    @ContentChild(NgForOf) private ngFor: NgForOf<any>;
    activeColumn: string;

    public doSort(key: string, direction: SortDirection, sorter?: Sorter): void {
        this.activeColumn = key;
        if (this.ngFor && this.sortable) {
            if (!sorter) {
                this.ngFor.ngForOf = _.orderBy(this.sortable, [key], [direction]);
            } else {
                this.ngFor.ngForOf = _.orderBy(this.sortable, val => sorter.getWeight(key, val) , [direction]);
            }
        }
    }
}
